import React from "react";

import { ArrowLeftOutlined, CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";

import flaskIcon from "../../../../../assets/images/product/specmanager/flask-fill.svg";

const ModalHeader = ({
  title,
  onClose,
  showBackButton = false,
  onBack,
  stepIndicator = null,
}) => (
  <div className="ProdSpecManagerModal__Header">
    <div className="ProdSpecManagerModal__HeaderLeft">
      {showBackButton && (
        <Button
          htmlType="button"
          className="ProdSpecManagerModal__BackButton"
          onClick={onBack}
          aria-label="Go back"
        >
          <ArrowLeftOutlined />
        </Button>
      )}
      <img src={flaskIcon} alt="spec manager icon" className="ProdSpecManagerModal__FlaskIcon" />
      <span className="ProdSpecManagerModal__Title">{title}</span>
    </div>
    <div className="ProdSpecManagerModal__HeaderRight">
      {stepIndicator && (
        <div className="ProdSpecManagerModal__StepIndicator">
          {stepIndicator}
        </div>
      )}
      <CloseOutlined
        className="SpecManager__Header--icon"
        aria-label="Close"
        onClick={onClose}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if ((e.key === "Enter" || e.key === " ") && onClose) {
            onClose();
          }
        }}
      />
    </div>
  </div>
);

export default ModalHeader;
